import React, { useState, useEffect } from 'react'
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Box,
  List,
  Drawer,
} from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import { alpha } from '@mui/material/styles'
import { useTheme } from '@mui/material/styles'
import backgroundImage from '../assets/Istanbul.jpg'
import background2 from '../assets/Taba.jpg'
import background3 from '../assets/Nuweiba.jpg'
import background4 from '../assets/ankara.jpg'
import background5 from '../assets/Sharm El Sheikh.jpg'
import background6 from '../assets/antalya.jpg'
import background7 from '../assets/Cairo3.jpg'
import Divider from '@mui/material/Divider'
import { IconButton, ListItem, ListItemText } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import MenuIcon from '@mui/icons-material/Menu'
import { useMediaQuery } from '@mui/material'
import { motion, AnimatePresence } from 'framer-motion'
import LanguageDropdown from './change lang'
import { useTranslation } from 'react-i18next'
import CToolBar from './tool_bar'
const Navbar = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const { state } = useLocation()
  const [scrolled, setScrolled] = useState(false)
  const [index, setIndex] = useState(0)
  const images =
    location.pathname === '/'
      ? [
          backgroundImage,
          background2,
          background3,
          background4,
          background5,
          background6,
          background7,
        ]
      : 'none'
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const currentPath = location.pathname
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 500
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled)
      }
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [scrolled])
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length)
    }, 5000)
    return () => clearInterval(interval)
  }, [images.length])

  // const renderMobileMenu = () => (
  //   <Container
  //     sx={{
  //       zIndex: 2,
  //       width: '100%',
  //       maxWidth: '100%',
  //       backgroundColor: 'white',
  //       borderRadius: '10px',
  //     }}
  //   >
  //     <List>
  //       <ListItem sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' ,textDecoration: 'none',borderBottom: '3px solid #e0e0e0'}}>
  //         <Link to="/" style={{textDecoration: 'none',color: '#13294b',fontWeight: 900}} onClick={() => setMobileMenuOpen(false)}>
  //           <ListItemText primary="Home" />
  //         </Link>
  //       </ListItem>
  //       <ListItem sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' ,textDecoration: 'none',borderBottom: '3px solid #e0e0e0'}}>
  //         <Link to="/services" style={{textDecoration: 'none',color: '#13294b',fontWeight: 900}} onClick={() => setMobileMenuOpen(false)}>
  //           <ListItemText primary="services" />
  //         </Link>
  //       </ListItem>
  //       <ListItem sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' ,textDecoration: 'none',borderBottom: '3px solid #e0e0e0'}}>
  //         <Link to="/about" style={{textDecoration: 'none',color: '#13294b',fontWeight: 900}} onClick={() => setMobileMenuOpen(false)}>
  //           <ListItemText primary="About" />
  //         </Link>
  //       </ListItem>
  //       <ListItem sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' ,textDecoration: 'none',borderBottom: '3px solid #e0e0e0'}}>
  //         <Link to="/contact" style={{textDecoration: 'none',color: '#13294b',fontWeight: 900}} onClick={() => setMobileMenuOpen(false)}>
  //           <ListItemText primary="Contact" />
  //         </Link>
  //       </ListItem>
  //     </List>
  //     <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
  //       <IconButton
  //         onClick={() => setMobileMenuOpen(false)}
  //         sx={{ color: 'secondary.main', fontSize: '24px',fontWeight: 900 ,backgroundColor: 'primary.main',margin: '0 10px'}}
  //       >
  //         <CloseIcon />
  //       </IconButton>
  //     </Box>

  //   </Container>

  // );
  const navigationItems = [
    t('Titles.Home'),
    t('Titles.services1'),
    t('Titles.about'),
    t('Titles.contact'),
  ]
  const Navigation = ['/', '/services', '/about', '/contact']
  // const scrollToSection = (section) => {
  //   const element = document.getElementById(section);
  //   if (element) {
  //     setActiveSection(section);
  //   }
  // };

  const renderMobileMenu = () => (
    <Drawer
      anchor="right"
      open={mobileMenuOpen}
      onClose={() => setMobileMenuOpen(false)}
      slotProps={{
        paper: {
          sx: {
            width: '90%',
            maxWidth: '300px',
            backgroundColor: 'text.secondary',
          },
        },
      }}
    >
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <IconButton
          color="inherit"
          onClick={() => setMobileMenuOpen(false)}
          sx={{ color: 'primary.main' }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <List>
        {navigationItems.map((section) => (
          <ListItem
            key={section}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textDecoration: 'none',
              borderBottom: '3px solid #e0e0e0',
            }}
          >
            <Link
              key={section}
              to={Navigation[navigationItems.indexOf(section)]}
              onClick={() => setMobileMenuOpen(false)}
              style={{
                textDecoration: 'none',
                color: '#13294b',
                fontWeight: 900,
              }}
            >
              <ListItemText
                primary={section.charAt(0).toUpperCase() + section.slice(1)}
                sx={{
                  ml: 2,
                  color: 'text.primary',
                  borderBottom: 'none', // Remove any bottom line
                }}
              />
            </Link>
          </ListItem>
        ))}
      </List>
    </Drawer>
  )
  return (
    <>
      {scrolled && (
        <>
          <AppBar
            position="fixed"
            sx={{
              backgroundColor: alpha(theme.palette.secondary.main, 0.9),
              transition: 'all 0.3s',
              margin: '0',
              padding: '0',
            }}
          >
            <CToolBar
              currentPath={location.pathname}
              t={t}
              isMobile={isMobile}
              mobileMenuOpen={mobileMenuOpen}
              setMobileMenuOpen={setMobileMenuOpen}
            />
          </AppBar>
        </>
      )}

      <AppBar
        position="relative"
        sx={{
          backgroundColor: 'transparent',
          width: '100%',
          minWidth: '100%',
          // backgroundImage: `linear-gradient(rgba(201, 105, 20, 0.5), rgba(201, 105, 20, 0.8)),
          //  url(${backgroundImage})` ,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '70vh',
          gap: 2,
          overflow: 'hidden', // Prevents extra spacing
          boxSizing: 'border-box', // Ensures padding doesn't increase width
        }}
      >
        <Container
          disableGutters
          style={{
            position: 'fixed',
            width: '100%',
            height: '70vh',
            minWidth: '100%',
            overflow: 'hidden',
            zIndex: location.pathname === '/' ? 0 : -1,
          }}
        >
          <AnimatePresence>
            <motion.div
              key={index}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 2, ease: 'easeInOut', delay: 0.5 }}
              style={{
                backgroundRepeat: 'repeat',
                position: 'absolute',
                width: '100%',
                height: '70vh',
                backgroundImage: `url(${images[index]})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            />
          </AnimatePresence>
        </Container>
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            background: 'rgb(78, 92, 35,0.59)', // Adjust darkness of the shadow
            zIndex: 1, // Keeps shadow above the background
          }}
        />
        <Toolbar
          sx={{
            gap: 1,
            zIndex: 2,
            fontFamily: 'Montserrat',
            display: 'flex',
            justifyContent: { xs: 'space-between', md: 'space-evenly' },
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Typography
              variant="h6"
              component="div"
              sx={{
                flexGrow: 1,
                cursor: 'pointer',
                fontWeight: 700,
                // background: 'linear-gradient(45deg, #00bcd4 30%, #80deea 90%)',
                WebkitBackgroundClip: 'text',
              }}
            >
              <img
                src="/logo-Photoroom.png"
                alt="Logo"
                style={{ width: '160px', height: '160px' }}
              />
            </Typography>
          </Link>
          <LanguageDropdown />
          {isMobile && !mobileMenuOpen && (
            <IconButton
              onClick={() => setMobileMenuOpen(true)}
              sx={{
                position: 'relative', // Ensures it's above other elements
                color: 'secondary.main',
                backgroundColor: 'primary.main',
                zIndex: 999, // Keeps it clickable
                width: '50px',
                height: '50px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <MenuIcon />
            </IconButton>
          )}
          {/* Mobile Navigation Drawer */}

          {!isMobile && (
            <Box
              sx={{
                display: 'flex',
                gap: 2,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Button
                color="inherit"
                component={Link}
                to="/"
                sx={{
                  fontFamily: 'Montserrat',
                  textDecoration: 'none',
                  color: 'text.secondary',
                  fontSize: '16px',
                  fontWeight: currentPath === '/' ? 900 : 600,
                  '&:hover': {
                    fontWeight: 900,
                  },
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: '0',
                    left: '0',
                    width: currentPath === '/' ? '100%' : '0',
                    height: '4px',
                    backgroundColor: '#327d81',
                    transition: 'width 0.3s ease-in-out',
                  },
                }}
              >
                {t('Titles.Home')}
              </Button>
              <Button
                color="inherit"
                component={Link}
                to="/services"
                sx={{
                  fontFamily: 'Montserrat',
                  textDecoration: 'none',
                  fontSize: '16px',
                  color: 'text.secondary',
                  fontWeight: currentPath === '/services' ? 900 : 600,
                  '&:hover': {
                    fontWeight: 900,
                  },
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: '0',
                    left: '0',
                    width: currentPath === '/services' ? '100%' : '0',
                    height: '4px',
                    backgroundColor: '#327d81',
                    transition: 'width 0.3s ease-in-out',
                  },
                }}
              >
                {t('Titles.services1')}
              </Button>
              <Button
                color="inherit"
                component={Link}
                to="/about"
                sx={{
                  fontFamily: 'Montserrat',
                  textDecoration: 'none',
                  fontSize: '16px',
                  color: 'text.secondary',
                  fontWeight: currentPath === '/about' ? 900 : 600,
                  '&:hover': {
                    fontWeight: 900,
                  },
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: '0',
                    left: '0',
                    width: currentPath === '/about' ? '100%' : '0',
                    height: '4px',
                    backgroundColor: '#327d81',
                    transition: 'width 0.3s ease-in-out',
                  },
                }}
              >
                {t('Titles.about')}
              </Button>
              <Button
                color="inherit"
                component={Link}
                to="/contact"
                sx={{
                  fontFamily: 'Montserrat',
                  textDecoration: 'none',
                  fontSize: '16px',
                  color: 'text.secondary',
                  fontWeight: currentPath === '/contact' ? 900 : 600,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    // borderBottom: '4px solid #327d81', // Keep the border on hover
                    fontWeight: 900,
                  },
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: '0',
                    left: '0',
                    width: currentPath === '/contact' ? '100%' : '0',
                    height: '4px',
                    backgroundColor: '#327d81',
                    transition: 'width 0.3s ease-in-out',
                  },
                }}
              >
                {t('Titles.contact')}
              </Button>
            </Box>
          )}
        </Toolbar>
        <Container
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            flexDirection: 'column',
            zIndex: 1,
          }}
        >
          <br />
          <Typography
            variant="h2"
            component="div"
            sx={{
              color: 'text.secondary',
              fontWeight: 700,
              fontFamily: 'Montserrat',
              fontSize: {
                xs: location.pathname === '/' ? '1.5rem' : '2rem',
                md: location.pathname === '/' ? '2.5rem' : '3rem',
              },
            }}
          >
            {location.pathname === '/'
              ? t('Titles.world')
              : location.pathname === '/services'
              ? t('Titles.services')
              : location.pathname === '/about'
              ? t('Titles.about_us')
              : location.pathname === '/contact'
              ? t('Titles.contact_us')
              : location.pathname === `/details/${state.index}`
              ? `${t(`${state.destination?.key}.title`)}`
              : 'Our Services'}
          </Typography>
          {location.pathname === '/' && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                paddingTop: '20px',
                flexDirection: 'column',
              }}
            >
              <Divider
                sx={{
                  backgroundColor: 'primary.main',
                  width: '10vh',
                  height: '4px',
                }}
              />
              <Button
                sx={{
                  color: 'text.secondary',
                  backgroundColor: 'primary.main',
                  marginTop: '20px',
                  borderRadius: '30px',
                  width: '200px',
                  height: '50px',
                  fontSize: '16px',
                  fontWeight: 600,
                  fontFamily: 'Montserrat',
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    backgroundColor: 'secondary.main', // Change background color on hover
                    color: 'text.secondary', // Change text color on hover
                    transform: 'scale(1.05)', // Slightly increase size on hover
                  },
                }}
                component={Link}
                to="/about"
              >
                {t('Titles.learn_more')}
              </Button>
            </Box>
          )}
        </Container>
        {mobileMenuOpen && isMobile && renderMobileMenu()}
      </AppBar>
    </>
  )
}

export default Navbar
